export default __webpack_public_path__ + "static/9_37-97d8e74a5d9fe3a96e58466799021137.png";